/**
 * Schema of ResponsavelUsuarioCSV
 */
import {bool, InputType, Schema} from 'simpli-web-sdk'
import ResponsavelUsuarioCSV from '@/model/resource/ResponsavelUsuarioCSV'

export default (model: ResponsavelUsuarioCSV): Schema => ({
  nome: {
    content: model.nome,
  },

  email: {
    content: model.email,
  },

  tipoResponsavelUsuario: {
    content: model.tipoRespUsuario && model.tipoRespUsuario.$tag || '',
  },

  filial: {
    content: model.filialName,
  },

  ativo: {
    content: bool(model.ativo),
    input: InputType.CHECKBOX,
  },

})
